// extracted by mini-css-extract-plugin
module.exports = {"GridContainer":"InicioScreen_GridContainer__ec3gd","VendasContainer":"InicioScreen_VendasContainer__1uuPK","TableContainer":"InicioScreen_TableContainer__3TEFG"};